import React, { useState } from "react";
import { ApiService, getProductTitle } from "../services";
import { Slider } from "@mui/material";
import { useSnackbar } from "notistack";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GButton from "../Elements/GButton";
import ProductImages from "../Pages/productImages";
import GMap from "../Elements/gMaps";
import GTabs from "../Elements/gTabs";
import ProductUnits from "../Pages/productUnits";
import styled from "styled-components";

const Div = styled.div`
.MuiSlider-root {
    color: #F8310E;
    `;

export default function ProductEditForm(props) {
  const productTypes = ["basic_info", "images", "Table"];
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [productImages, setProductImgaes] = useState(props.data.images || []);

  const [typeValue, setTypeValue] = useState(productTypes[0]);

  const initialValues = props.fields.reduce(
    (a, v) => ({
      ...a,
      [v?.id]: v?.value
        ? v.value
        : v?.type == "checkbox"
        ? v.value == 1
          ? 1
          : 0
        : "",
    }),
    {
      address: props.data?.address || "",
      lat: props.data?.lat || "",
      lng: props.data?.lng || "",
      price_from: props.data?.price_from || 0,
      price_upto: props.data?.price_upto || 30,
      units: props.data?.units || "",
      min_users: props.data?.min_users || "",
      max_users: props.data?.max_users || "",
    }
  );

  function salaryValueLabelFormat(value) {
    return `${Math.round(value)}`;
  }

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    console.log(values);

    let sendData = {
      custom_fields: values,
      address: values.address,
      price_from: values.price_from || 0,
      price_upto: values.price_upto || 30,
      lat: values.lat,
      lng: values.lng,
      units: values.units,
      min_users: values.min_users,
      max_users: values.max_users,
    };
    ApiService({
      method: "PUT",
      route: "products/" + props.data.id,
      body: sendData,
    }).then((response) => {
      console.log(response.data);
      if (response.data.status_code === 1) {
        props.setPevisible(false);
        props.onSubmit();
      }
      setIsBtnDisabled(false);
      enqueueSnackbar(response.data.message);
      return;
    });
  };

  const validationSchema = Yup.object({
    address: Yup.string().required(),
  }).shape(
    props.fields
      .filter((t) => t.required)
      .reduce(
        (a, v) => ({
          ...a,
          [(v?.id).toString()]:
            v.type == "checkbox"
              ? ""
              : Yup.string()
                  .nullable()
                  .required(v.title + " is required"),
        }),
        {}
      )
  );

  if (props.pevisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header"> Edit {getProductTitle()}</div>

      <div
        className="modal-body"
        style={{ padding: "10px 0", overflow: "hidden" }}
      >
        <GTabs
          routes={productTypes}
          active={typeValue}
          type="single"
          onClick={(newVal) => setTypeValue(newVal)}
          style={{ borderBottom: "1px solid #e2e2e2" }}
        ></GTabs>

        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              {typeValue == "basic_info" && (
                <div
                  style={{
                    overflow: "overlay",
                    height: "calc(100vh - 160px)",
                    padding: "20px",
                  }}
                >
                  <GMap
                    centerLocation={{
                      lat: values?.lat ? parseFloat(values.lat) : 30.7046,
                      lng: values?.lng ? parseFloat(values.lng) : 76.7179,
                    }}
                    search={true}
                    height="30vh"
                    type="createStore"
                    onChange={(address, loc) => {
                      values.lat = loc.lat();
                      values.lng = loc.lng();
                      setFieldValue("address", address.address);
                    }}
                    label="Location"
                    padding={true}
                  />
                  <FormikControl
                    control="input"
                    type="text"
                    label="Address"
                    name="address"
                  />
                  <Div
                    style={{
                      padding: "6px 15px",
                    }}
                  >
                    <label>
                      Price (
                      {props.settings.currency_symbol + values.price_from} -{" "}
                      {props.settings.currency_symbol + values.price_upto})
                    </label>
                    <Slider
                      min={0}
                      max={100}
                      step={1}
                      defaultValue={[
                        values.price_from || 0,
                        values.price_upto || 30,
                      ]}
                      onChange={(e, val) => {
                        console.log(e);
                        console.log(val);
                        setFieldValue("price_from", val[0]);
                        setFieldValue("price_upto", val[1]);
                      }}
                      valueLabelDisplay="auto"
                      aria-labelledby="range-slider"
                      getAriaValueText={salaryValueLabelFormat}
                      valueLabelFormat={salaryValueLabelFormat}
                    />
                  </Div>
                  {props.fields.map((f, i) => (
                    <React.Fragment key={i}>
                      {f.type == "select" && (
                        <FormikControl
                          control="selectOption"
                          as="select"
                          label={f.title}
                          name={f.id.toString()}
                          options={f.answers}
                          key_title="title"
                          key_value="id"
                          divstyle={{
                            display: "inline-block",
                            width: "50%",
                            boxSizing: "border-box",
                            verticalAlign: "top",
                          }}
                        />
                      )}
                      {f.type == "text" && (
                        <FormikControl
                          control="input"
                          type="text"
                          label={f.title}
                          name={f.id}
                        />
                      )}
                      {f.type == "textarea" && (
                        <FormikControl
                          control="input"
                          as="textarea"
                          label={f.title}
                          name={f.id}
                        />
                      )}

                      {f.type == "checkbox" && (
                        <FormikControl
                          control="singleCheckbox"
                          as="checkbox"
                          label={f.title}
                          name={f.id}
                          checked={values[f.id] == 1 ? true : false}
                          onChange={(e) => {
                            values[f.id] = e.target.checked == true ? 1 : 0;
                            setFieldValue(
                              f.id,
                              e.target.checked == true ? 1 : 0
                            );
                          }}
                        />
                      )}
                    </React.Fragment>
                  ))}

                  <GButton
                    type="submit"
                    disabled={isBtnDisabled}
                    variant="condensed"
                    children="Update"
                    style={{ width: "calc(100% - 30px)", margin: "15px" }}
                  />
                </div>
              )}
            </Form>
          )}
        </Formik>

        {typeValue == "images" && (
          <div
            style={{
              overflow: "overlay",
              height: "calc(100vh - 160px)",
              padding: "20px",
            }}
          >
            <div style={{ margin: "15px" }}>
              <ProductImages
                onUpload={(data) => {
                  setProductImgaes([...productImages, data]);
                }}
                onRemove={(id) => {
                  setProductImgaes(
                    productImages.filter((item) => item.id !== id)
                  );
                }}
                productImages={productImages}
                add={true}
                productId={props.data.id}
              />
            </div>
          </div>
        )}

        {typeValue == "Table" && (
          <div
            style={{
              overflow: "overlay",
              height: "calc(100vh - 160px)",
              padding: "20px",
            }}
          >
            <ProductUnits productId={props.data?.id} />
          </div>
        )}
      </div>
    </>
  );
}
